/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc, debug */

	/**
	 * InfoTeaserContainer
	 *
	 * @author tzhveig1
	 * @namespace Tc.Module
	 * @class InfoTeaserContainer
	 * @extends Tc.Module
	 */

	Tc.Module.InfoTeaserContainer = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
			$ctx = mod.$ctx

			if ($ctx.hasClass('zigzag')){
				mod.zigzagDataProviderItems();
			}

			callback();
		},

		after: function() {
			var mod = this,
			$ctx = mod.$ctx,
			height = 0;

			$ctx.find('.modDataProvider .data-provider-item').each(function() {
				height = ($(this).height() > height) ? $(this).height() : height;
			});

			debug.log('Tc.Module.InfoTeaserContainer > maxheight', height);
			$ctx.find('.modDataProvider .data-provider-item').height(height).addClass('float');

		},

		zigzagDataProviderItems: function(){
			var mod = this,
				$items = mod.$ctx.find('.data-provider-item');

			for (var i = 0; i < $items.length; i ++){
				$items.eq(i).addClass((i & 1) ? 'zag' : 'zig');
			}
		}

	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.InfoTeaserContainer.js
// module id = 149
// module chunks = 0